// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationPagePropertyCardImage_image_graphql = require("../../../__generated__/ConversationPagePropertyCardImage_image_graphql.bs.js");

let convertFragment = ConversationPagePropertyCardImage_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPagePropertyCardImage_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPagePropertyCardImage_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPagePropertyCardImage_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPagePropertyCardImage_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPagePropertyCardImage(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let image = RescriptRelay_Fragment.useFragment(ConversationPagePropertyCardImage_image_graphql.node, convertFragment, props.image);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("img", {
      className: "w-full h-full object-cover absolute inset-0",
      alt: "Property image",
      src: image.url
    }),
    className: TailwindMerge.twMerge([
      "w-1/4 relative",
      className
    ])
  });
}

let make = ConversationPagePropertyCardImage;

exports.ImageFragment = ImageFragment;
exports.make = make;
/* tailwind-merge Not a pure module */
